module.exports = __webpack_public_path__ + "img/hyl_p1.0d8c17da.png";